export const TABLE_COLUMN_TYPES = [
  { label: "Texte", value: "string" },
  { label: "Nombre", value: "number" },
  { label: "Date", value: "date" },
  { label: "Choix multiple", value: "enum-key-value" },
  { label: "Relation", value: "enum-relation" },
  { label: "API", value: "enum-api" },
  { label: "Boolean", value: "boolean" },
  { label: "Fichier", value: "file" },
];
